import { render, staticRenderFns } from "./FooterTop.vue?vue&type=template&id=708e40a2&scoped=true"
import script from "./FooterTop.vue?vue&type=script&lang=js"
export * from "./FooterTop.vue?vue&type=script&lang=js"
import style0 from "./FooterTop.vue?vue&type=style&index=0&id=708e40a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708e40a2",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FooterTopFormNewsletter: require('/app/components/FooterTopFormNewsletter.vue').default})
